import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { EapStudyTeamOrganizationViewModalComponent } from './eap-study-team-organization-view-modal/eap-study-team-organization-view-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-eap-study-team-organization',
  templateUrl: './eap-study-team-organization.component.html',
  styleUrls: ['./eap-study-team-organization.component.scss']
})
export class EapStudyTeamOrganizationComponent implements OnInit {

  columnDefs;
  operations;
  tempoperation;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  ApplicationID: string;
  organisationType = [];
  StudyTeamOrganization: UntypedFormGroup;
  permission: string = "";
  userType: string = "";
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
  ) {
  }

  ngOnInit() {
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    debugger;
    if (this.ApplicationID == "" || this.ApplicationID == undefined || this.ApplicationID == null) {
     // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Please save the first form of the application, before navigating to the other forms." } } });
      return false;
    }
    this.permission = "";
    if (this.commonService.getPagePermission("EAP03") != null && this.commonService.getPagePermission("EAP03") != undefined) {
      this.permission = this.commonService.getPagePermission("EAP03").toLowerCase();
    }
    debugger;
    this.userType = this.userService.getUserType();
    this.StudyTeamOrganization = new UntypedFormGroup({
      NAME: new UntypedFormControl(null),
      City: new UntypedFormControl(null),
      TYPE: new UntypedFormControl(null),
      PhoneNumber: new UntypedFormControl(null),
    });

   

   
    this.columnDefs= [
      {
        "headerName": "Name",
        "field": "NAME",
        "sort": "asc"
      },
      {
        "headerName": "City",
        "field": "City"
      },
      {
        "headerName": "Type",
        "field": "TYPE"
      },
      {
        "headerName": "Phone Number",
        "field": "PhoneNumber"
      },
      {
        "headerName": "Other Phone Number",
        "field": "OtherPhoneNumber"
      }
    ],

    this.getMasterData();



    this.tempoperation = [
     
    ];
   
    this.advanceSearch=
    {
      "fields": [
        {
          "label": "Name",
          "field": "name",
          "type": "text"
        },
        {
          "label": "City",
          "field": "city",
          "type": "text"
        },
        {
          "label": "Type",
          "field": "type",
          "type": "dropdown",
          "options": this.organisationType,
        },
        {
          "label": "Phone Number",
          "field": "phoneNumber",
          "type": "text"
        }
      ]
    }

   
    if (this.ApplicationID == "" || this.ApplicationID == undefined || this.ApplicationID == null) {
      //this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Please save the first form of the application, before navigating to the other forms." } } });
      return false;
    }
    
   
    this.setSummaryData();
  }
  onAdvanceSearchOperation(searchFiletrs) {
  
  }


  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }


  onCallbackOperation(opr) {
    opr.callback(this.summaryService);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    // this.modalService.show(EapStudyTeamOrganizationViewModalComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   ignoreBackdropClick: true,
    //   class:'modal-vlg modal-full-height modal-right',
    //   animated: true,
    //   data: {
    //     heading: 'View',
    //     content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
    //   }
    // });
  }

  add() {
    // if (this.ApplicationID != "") {
    //   let modalRef = this['self'].modalService.show(EapStudyTeamOrganizationViewModalComponent, {
    //     backdrop: false,
    //     keyboard: false,
    //     ignoreBackdropClick: true,
    //     class: 'modal-vlg modal-full-height modal-right',
    //     animated: true,
    //     data: {
    //       heading: 'Add',
    //       content: { id: '', ApplicationID: this.ApplicationID }
    //     }
    //   });
    //   modalRef.content.action.subscribe(result => {
    //     this['self'].setSummaryData();
    //   })
    // }
    // else {
    //   this.modalService.show(MessageBoxComponent, { data: { heading: 'aleart', content: { heading: '', description: 'Please save General Information first.' } } });
    // }
  
  }

  edit() {
    // debugger;
    // let modalRef = this['self'].modalService.show(EapStudyTeamOrganizationViewModalComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   ignoreBackdropClick: true,
    //   class:'modal-vlg modal-full-height modal-right',
    //   animated: true,
    //   data: {
    //     heading: 'Edit',
    //     content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }
    //   }
    // });
    // modalRef.content.action.subscribe(result=>{
    //   this['self'].setSummaryData();
    // })
  }

  delete(service, toastrService) {
    // //service.DeleteRecord('api/EAPOrganization/Delete?RecordID=' + this['self'].selectedRow.ID).subscribe(summary => {
    // //  this["self"].modalRef = this["self"].modalService.show(DeleteBoxComponent);
    // //  this['self'].setSummaryData();
    // //});    //service.DeleteRecord('api/EAPOrganization/Delete?RecordID=' + this['self'].selectedRow.ID).subscribe(summary => {
    // //  this["self"].modalRef = this["self"].modalService.show(DeleteBoxComponent);
    // //  this['self'].setSummaryData();
    // //});
    // let id = this['self'].selectedRow['ID'];
    // if (this['self'].selectedRow["CREATED_BY"] != "Admin") {
    //   this["self"].modalRef = this["self"].modalService.show(DeleteBoxComponent);
    //   this["self"].modalRef.content.action.subscribe(result => {
    //     service.DeleteRecord('api/EAPOrganization/Delete?RecordID=' + id).subscribe(summary => {
    //       debugger;
    //       if (summary["Status"] == 0) {
    //         toastrService.success("Selected Record(s) has been Deleted");
    //         this['self'].setSummaryData();
    //       }
    //       else {
    //         toastrService.error("Selected Record(s) has been Deleted");

    //       }
    //     });
    //   })
    // }
    // else {
    //   this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Alert', content: { heading: '', description: "Default Record can't be Deleted." } } });
    // }
  }
  getMasterData() {
    this.organisationType = [];
    this.summaryService.getSummaryData('api/EAPOrganization/GetMasterData?ApplicationID=' + this.ApplicationID).subscribe(summary => {
      this.organisationType = summary["MasterData1"];
       // if (this.permission == "new") {
          
          this.tempoperation.push({
            "name": "Edit",
            "id": "edit"
          });
          //this.tempoperation.push({
          //  "name": "Delete",
          //  "id": "delete"
          //});
       // }
        this.operations = this.tempoperation.map(operation => {
          return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
        });
    });
  }
  setSummaryData() {
    this.SearchClear();
    if (this.ApplicationID != "" && this.ApplicationID != undefined) {
      this.summaryService.getSummaryData('api/EAPOrganization/GetSummaryData?ApplicationID=' + this.ApplicationID).subscribe(summary => {
        this.rowData = summary
      });
    }
    else {
      this.rowData = [];
    }
  }

  fetchSearchData(searchObject) {
    this.summaryService.fetchSearchData('api/EAPOrganization/GetSummarySearchData', searchObject).subscribe(summary => {
      this.rowData = summary
    });
  }
  //// Advace search Functions
  SearchClear() {
    this.StudyTeamOrganization.reset();
    //  this.setSummary();
  }
  AdvanceSearch() {
    var formData = this.StudyTeamOrganization.value;
    debugger;
    formData["ApplicationID"] = this.ApplicationID;
    this.fetchSearchData(formData);
  }


}
